import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api, { IMAGE_BASE_URL } from "../../api/Api.js";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const AddBlogPage = () => {

const imagePath = `${IMAGE_BASE_URL}/uploads/blogs/`;
const { pageID } = useParams();
const blogId = pageID;
const [isSubmitting, setIsSubmitting] = useState(false);
const [title, setTitle] = useState("");
const [getBlogLink, setBlogLink] = useState("");
const [sbTitle, setSbTitle] = useState("");
const [description, setDescription] = useState("");
const [content, setContent] = useState("");
const [getMetaKey, setMetaKey] = useState("");
const [getMetaDescription, setMetaDescription] = useState("");
const [getKeyword, setKeyword] = useState("");
const [autherName, setAutherName] = useState("");
const [pageimg, setPageimg] = useState([]);
const [preview, setPreview] = useState([]);
const [oldImages, setOldImages] = useState([]);
const [imageRows, setImageRows] = useState([
{ image: null, preview: "", altTitle: "", oldImage: "" }
]);
const [updateBy, setUpdateBy] = useState("");
 const [updatedDate, setUpdatedDate] = useState(
  new Date().toISOString().split("T")[0]
);
const [getAddedDate, setAddedDate] = useState("");
const [categories, setCategories] = useState([]);
const [tags, setTags] = useState([]);
const [selectedCategory, setSelectedCategory] = useState("");
const [selectedTags, setSelectedTags] = useState([]);
const [getYoutubeLink, setYoutubeLink] = useState("");
useEffect(() => {
fetchBlogDataEdit();
fetchCategoryData();
fetchTagsyData();
}, []);
const fetchCategoryData = async () => {
try {
const res = await api.get("/adminBlog/getCategoryDataBlog");
setCategories(res.data?.data || []);
} catch (error) {
toast.error("Failed to load category data");
}
};
const fetchTagsyData = async () => {
try {
const res = await api.get("/adminBlog/getTagDataBlog");
setTags(res.data?.data || []);
} catch (error) {
toast.error("Failed to load Tags data");
}
};
// =========================
// FETCH BLOG DATA
// =========================
const fetchBlogDataEdit = async () => {
  try {
    const res = await api.get(`/adminBlog/getblogDataEdit/${blogId}`);
    const data = res.data?.data?.[0];

    setTitle(data.title);
    setBlogLink(data.blogLink);
    setSbTitle(data.sub_title);
    setDescription(data.description);
    setContent(data.pageContent);
    setAutherName(data.autherName);
    setMetaKey(data.metaKey || "");
    setMetaDescription(data.metaDescription || "");
    setKeyword(data.keyword || "");
    setUpdateBy(data.updateBy || "");
    setSelectedCategory(data.category || "");
    setYoutubeLink(data.youTube_link || "");

    // ✅ TAG FIX
    let parsedTags = [];
    try {
      if (Array.isArray(data.tags)) {
        parsedTags = data.tags;
      } else if (typeof data.tags === "string") {
        parsedTags = data.tags.startsWith("[")
          ? JSON.parse(data.tags)
          : data.tags.split(",");
      }
    } catch (err) {
      parsedTags = [];
    }
    setSelectedTags(parsedTags);

    // DATE FIX
    
    if (data.addedDt) {
      const d = new Date(data.addedDt);
      setAddedDate(
        `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`
      );
    }

    // MAIN IMAGES
    const imageArray = data.pageimg ? data.pageimg.split(",") : [];
    setOldImages(imageArray);

    // ✅ EXTRA IMAGES FIX (MAIN FIX HERE)
    let extraImages = [];
    try {
      extraImages = JSON.parse(data.extraImages || "[]");
    } catch (err) {
      extraImages = [];
    }

    const formatted = extraImages.map((item) => ({
  image: null,
  preview: "",
  altTitle: item?.altTitle || "",
  oldImage: item?.image || ""
}));

let maxNumber = 0;

formatted.forEach((item) => {

  const match = item.altTitle?.match(/-(\d+)$/);

  if (match) {

    const num = parseInt(match[1], 10);

    if (num > maxNumber) {
      maxNumber = num;
    }

  }

});

setLastAltNumber(maxNumber);

setImageRows(
  formatted.length > 0
    ? formatted
    : [{
        image: null,
        preview: "",
        altTitle: "",
        oldImage: ""
      }]
);
  } catch (error) {
    toast.error("Failed to load blog data");
  }
};
// =========================
// MAIN IMAGE
// =========================
const handleImageChange = (e) => {
const files = Array.from(e.target.files);
setPageimg(files);
const previewUrls = files.map(file =>
URL.createObjectURL(file)
);
setPreview(previewUrls);
};
// =========================
// EXTRA IMAGE ROWS
// =========================
const handleRowImageChange = (index, file) => {
const updated = [...imageRows];
updated[index].image = file;
updated[index].preview = URL.createObjectURL(file);
setImageRows(updated);
};
const handleAltTitleChange = (index, value) => {
  const updated = [...imageRows];

  if (!updated[index]) return;

  updated[index] = {
    ...updated[index],
    altTitle: value
  };

  setImageRows(updated);
};



const [lastAltNumber, setLastAltNumber] = useState(0);

const addImageRow = () => {

  const nextNumber = lastAltNumber + 1;

  setImageRows([
    ...imageRows,
    {
      image: null,
      preview: "",
      altTitle: `${getBlogLink}-${nextNumber}`,
      oldImage: ""
    }
  ]);

  setLastAltNumber(nextNumber);

};


// const removeImageRow = (index) => {
//   setImageRows(imageRows.filter((_, i) => i !== index));
// };
const removeImageRow = async (index) => {
if (imageRows.length === 1) {
toast.error("At least one row required");
return;
}
const confirm = await Swal.fire({
title: "Delete Row?",
icon: "warning",
showCancelButton: true
});
if (!confirm.isConfirmed) return;
const updated = imageRows.filter(
(_, i) => i !== index
);
setImageRows(updated);
};
// =========================
// DELETE OLD IMAGE
// =========================
const handleDeleteOldImage = (index) => {
setOldImages(oldImages.filter((_, i) => i !== index));
};
// =========================
// UPDATE BLOG
// =========================
const saveBlog = async () => {
const confirm = await Swal.fire({
title: "Update Blog?",
icon: "question",
showCancelButton: true,
confirmButtonText: "Yes Update"
});
if (!confirm.isConfirmed) return;
setIsSubmitting(true);
try {
const blogLink = getBlogLink;
const cleanTags = selectedTags.filter(
  (tag) => tag && tag.trim() !== ""
);
const formData = new FormData();
formData.append("blogId", blogId);
formData.append("blogLink", blogLink);
formData.append("autherName", autherName);
formData.append("updateBy", updateBy);
formData.append("updatedDate", updatedDate);
formData.append("title", title);
formData.append("sbTitle", sbTitle);
formData.append("youTube_link", getYoutubeLink);
formData.append("category", selectedCategory);
formData.append("tags", JSON.stringify(cleanTags));
formData.append("description", description);
formData.append("pageContent", content);
formData.append("metaKey", getMetaKey);
formData.append("metaDescription", getMetaDescription);
formData.append("keyword", getKeyword);
// ===== OLD MAIN IMAGES =====
formData.append("oldImages", JSON.stringify(oldImages));
// ===== NEW MAIN IMAGES =====
pageimg.forEach((img) => {
formData.append("newMainImages", img); // 👈 backend ke liye alag name
});
// ===== EXTRA IMAGES =====
imageRows.forEach((row, i) => {
if (row.image) {
formData.append("newExtraImages", row.image); // 👈 backend ke liye alag name
// formData.append(`altTitle_${i}`, row.altTitle);
formData.append("newExtraAltTitles[]", row.altTitle); // ✅ send as array
} else {
formData.append(`oldExtra_${i}`, row.oldImage || "");
formData.append(`altTitle_${i}`, row.altTitle);
}
});
const res = await api.post("/adminBlog/UpdateBlog", formData, {
headers: { "Content-Type": "multipart/form-data" }
});
if (res.data.success) {
Swal.fire("Success", "Blog Updated Successfully", "success");
window.location.reload();
} else {
Swal.fire("Error", res.data.message, "error");
}
} catch (error) {
toast.error("Server error");
}finally {

    setIsSubmitting(false);

  }
};
const handleTagChange = (slug) => {
setSelectedTags((prev) =>
prev.includes(slug)
? prev.filter((tag) => tag !== slug)
: [...prev, slug]
);
};
return (
<div className="container-fluid py-3 bg-white min-vh-100">
   <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
      <div className="card-body d-flex justify-content-between">
         <h4 className="fw-bold">Edit Blog</h4>
         <Link
            to={"/blog-manage"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
            >
         <ArrowLeft size={16} />
         Back
         </Link>
      </div>
   </div>
   <div className="row">
      {/* LEFT SIDE */}
      <div className="col-lg-12">
         <table className="table">
            <tbody>
               {/* BLOG LINK */}
               {title.length > 0 && (
               <tr>
                  <th colSpan={2}>
                     <div className="d-flex align-items-center gap-2">
                        <i
                           className="fa fa-link text-primary"
                           aria-hidden="true"
                           ></i>
                        <input
                           type="text"
                           className="form-control"
                           onChange={(e) => setBlogLink(e.target.value)}
                        value={getBlogLink}
                        />
                     </div>
                  </th>
               </tr>
               )}
               {/* META */}
               <tr>
                  <th colSpan={2}>
                     <div className="d-flex align-items-center gap-2">
                        <span>Meta Title</span>
                        <small className={`d-block mt-1 ${
                           getMetaKey.length > 80 ? "text-danger" : "text-muted"
                        }`}>
                        ({getMetaKey.length}/80 Characters)
                        </small>
                     </div>
                  </th>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <input className="form-control" maxLength={80} value={getMetaKey} onChange={(e) => setMetaKey(e.target.value)} />
                     {getMetaKey.length >= 79 && getMetaKey.length <= 80 && (
                     <small className="text-danger">
                     ⚠️ Almost reached limit
                     </small>
                     )}
                  </td>
               </tr>
               <tr>
                  <th colSpan={2}>
                     <div className="d-flex align-items-center gap-2">
                        <span>Meta Description</span>
                        <small className={`d-block mt-1 ${
                           getMetaDescription.length > 160 ? "text-danger" : "text-muted"
                        }`}>
                        ({getMetaDescription.length}/160 Characters)
                        </small>
                     </div>
                  </th>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <textarea className="form-control"  rows="3"  maxLength={160} value={getMetaDescription} onChange={(e) => setMetaDescription(e.target.value)} />
               {getMetaDescription.length >= 159 && getMetaDescription.length <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                
                  </td>
               </tr>
               <tr>
               <th colSpan={2}>
               <div className="d-flex align-items-center gap-2">
               <span>Meta Keyword  </span><small className={`d-block mt-1 ${
                  getKeyword.length > 255 ? "text-danger" : "text-muted"
               }`}>
               ({getKeyword.length}/255 Characters)
               </small>
               </div>
               </th>
               </tr>
               <tr>
               <td colSpan={2}>
               <textarea
                  rows="3" maxLength={255} className="form-control" value={getKeyword} onChange={(e) => setKeyword(e.target.value)} ></textarea>
               {getKeyword.length >= 254 && getKeyword.length <= 255 && (
               <small className="text-danger">
               ⚠️ Almost reached limit
               </small>
               )}
               </td>
               </tr>
               <tr>
                  <th>Blog Category</th>
                  <th>Blog Tags</th>
               </tr>
               <tr>
                  <td>
                     {/* 
                     <pre>{JSON.stringify(tags, null, 2)}</pre>
                     */}
                     <select
                        className="form-control"
                        value={selectedCategory}
                        onChange={(e) =>
                        setSelectedCategory(e.target.value)}
                        >
                        <option value="" hidden>-- Select Category --</option>
                        {categories.map((cat) => (
                        <option key={cat.cat_id} value={cat.slug}>
                           {cat.name}
                        </option>
                        ))}
                     </select>
                  </td>
                  <td style={{width:"50%"}}>
                     <div className="d-flex flex-wrap gap-3">
                        {tags.map((tag) => (
                        <div key={tag.tags_id} className="form-check">
                           <input
                              className="form-check-input"
                              type="checkbox"
                              id={`tag-${tag.slug}`}
                              checked={selectedTags.includes(tag.slug)}
                              onChange={() =>
                           handleTagChange(tag.slug)
                           }
                           />
                           <label
                              className="form-check-label ms-1"
                              htmlFor={`tag-${tag.slug}`}
                              >
                           {tag.name}
                           </label>
                        </div>
                        ))}
                     </div>
                  </td>
               </tr>
               <tr>
                  <th>Page Title</th>
                  <th>Page Sub Title</th>
               </tr>
               <tr>
                  <td>
                     <input value={title} onChange={(e) => setTitle(e.target.value)} className="form-control" />
                  </td>
                  <td>
                     <input value={sbTitle} onChange={(e) => setSbTitle(e.target.value)} className="form-control" />
                  </td>
               </tr>
               <tr>
                  <th>
                     Author Name
                  </th>
                  <th>Date</th>
               </tr>
               <tr>
                  <td>
                     <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Author Name"
                        value={autherName}
                        onChange={(e) =>
                     setAutherName(e.target.value)
                     }
                     />
                  </td>
                  <td>
                     <input
                        className="form-control"
                        type="text"
                        value={getAddedDate}
                        readOnly
                        />
                  </td>
               </tr>
               {/*YOU TUBE LINK AREA SRAER */}
 <tr>
                <th colSpan={2}>
                  You Tube Link
                </th>
              </tr>
              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Enter You Tube Link"
                    value={getYoutubeLink}
                    onChange={(e) =>
                      setYoutubeLink(
                        e.target.value
                      )
                    }
                  ></textarea>

                </td>

              </tr>
{/* YOU TUBE LINK AREA END */}
               <tr>
                  <th colSpan={2}>Page  Description</th>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="form-control" />
                  </td>
               </tr>
               <tr>
                  <th colSpan={2}>Page Detailed Content</th>
               </tr>
               <tr>
                  <td colSpan={2}>
                     <CKEditor
                        editor={ClassicEditor}
                        data={content}
                        onChange={(e, editor) =>
                     setContent(editor.getData())}
                     />
                  </td>
               </tr>
               {/* EXTRA IMAGES TABLE (UNCHANGED STRUCTURE) */}
               <tr>
                  <th colSpan={2}>
                     <table className="table table-hover table-bordered">
                        <thead>
                           <tr>
                              <th>#</th>
                              <th>Upload Image</th>
                              <th>Alt Title</th>
                              <th>Image Preview</th>
                              <th>Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {imageRows.map((row, index) => (
                           <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                 <input type="file" className="form-control"
                                    onChange={(e) => handleRowImageChange(index, e.target.files[0])}
                                 />
                              </td>
                              <td>
                               {/* <input
  className="form-control"
  value={row.altTitle || ""} 
  onChange={(e) => handleAltTitleChange(index, e.target.value)}
/> */}


<input
  className="form-control"
  value={row.altTitle || ""}
  readOnly
/>
                              </td>
                              <td style={{textAlign:"center"}}>
                                 {(row.preview || row.oldImage) && (
                                 <img
                                 src={row.preview || `${imagePath}${row.oldImage}`}
                                 width="70"
                                 height="70"
                                 className="mt-2 rounded border"
                                 />
                                 )}
                              </td>
                              <td>
                                 <button className="btn btn-success btn-sm" onClick={addImageRow}>+</button>
                                 <button className="btn btn-danger btn-sm" onClick={() => removeImageRow(index)}>x</button>
                              </td>
                           </tr>
                           ))}
                        </tbody>
                     </table>
                  </th>
               </tr>
               <tr>
                  <th className="d-none">Update By</th>
                  <th>Updated date</th>
               </tr>
               <tr>
                  <td className="d-none">
                     <input
                        className="form-control"
                        placeholder="Enter Name"
                        type="text"
                        value={updateBy}
                        onChange={(e) =>
                     setUpdateBy(e.target.value)
                     }
                     />
                  </td>
                  <td>
                     <input
                        className="form-control"
                        type="date"
                        value={updatedDate}
                        onChange={(e) =>
                     setUpdatedDate(e.target.value)
                     }
                     />
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
      <div className="col-lg-12 text-center">
        

              <button
  className="btn btn-info text-white px-5 mt-3"
  onClick={saveBlog}
  disabled={isSubmitting}
>
  {isSubmitting ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      Submitting...
    </>
  ) : (
    "Update Blog"
  )}
</button>
      </div>
   </div>
</div>
);
};
export default AddBlogPage;